"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MixpanelAnalytics = void 0;
const mixpanel_browser_1 = __importDefault(require("mixpanel-browser"));
const isDevelopment = process.env.NODE_ENV === "development";
const isTest = !!process.env.IS_TEST_SERVER;
const MIXPANEL_PROD = "a1ef1d3ba86fe2c7e2f63ca5d717f63e";
const MIXPANEL_TEST = "d84b5bcdb0c2da97a0e28b4e3986dd07";
const MIXPANEL_DEV = "d84b5bcdb0c2da97a0e28b4e3986dd07";
const apiKey = isTest ? (isDevelopment ? MIXPANEL_DEV : MIXPANEL_TEST) : MIXPANEL_PROD;
mixpanel_browser_1.default.init(apiKey, { debug: isDevelopment });
////////////////////////////////////////////////
// Api
////////////////////////////////////////////////
exports.MixpanelAnalytics = {
    trackBusinessAction: (eventName, parameters) => trackEventToMixpanel(eventName, parameters),
    Business: {
        trackSignIn: (parameters) => trackEventToMixpanel("Sign In", parameters),
        trackSignOut: (parameters) => trackEventToMixpanel("Sign Out", parameters),
        trackAppState: (parameters) => trackEventToMixpanel("App State", parameters),
    },
    Tech: {
        trackSignInError: (value, ctx) => trackTechError("SignInError", value, ctx),
    }
};
const trackEventToMixpanel = (eventName, params) => {
    if (!isDevelopment) {
        mixpanel_browser_1.default.track(eventName, { ...params });
    }
    else {
        // mixpanel.track(eventName, {...params})
    }
    if (!!process.env.IS_TEST_SERVER) {
        console.log("Analytics Mixpanel: ", eventName, params);
    }
};
const trackTechError = (errorContext, errorValue, other) => trackEventToMixpanel("TechError", { ...other, errorContext: errorContext, errorValue: errorValue });
